var map = {
	"./enemies.json": [
		9704,
		9704
	],
	"./map.json": [
		5498,
		5498
	],
	"./ores.json": [
		6984,
		6984
	],
	"./packs.json": [
		7648
	],
	"./perks.json": [
		7524
	],
	"./spells.json": [
		8580,
		960
	],
	"./wTypes.json": [
		1696,
		1696
	],
	"./woods.json": [
		2130,
		2130
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1620;
module.exports = webpackAsyncContext;